
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.907 18.014a.776.776 0 00.06-.614.794.794 0 00-.41-.468c-.143-.07-14.413-7.04-20.095-7.04-5.685 0-19.954 6.97-20.097 7.041a.789.789 0 00-.41.467.776.776 0 00.06.614l3.406 6.302c.294.544 1.144 1.002 1.755.965l13.396-.834c.516-.034 1.198-.05 1.88-.05.67 0 1.342.016 1.855.049l13.44.835c.624.032 1.46-.422 1.754-.967l3.406-6.3zM38.39 28.497v-1.38a3.357 3.357 0 01-.577.057c-.063 0-.124-.001-.186-.006l-13.44-.836a35.09 35.09 0 00-3.493.001l-13.397.835c-.039.004-.08-.003-.118 0v1.329H38.39zM22.794 34.36c13.397 0 15.296-2.342 15.567-3.972H7.234c.294 1.58 2.27 3.972 15.56 3.972zm21.998-17.535a2.628 2.628 0 01-.194 2.079l-3.405 6.302c-.209.386-.522.732-.887 1.029v3.415h.018c0 .09-.014.17-.018.259v.479h-.032c-.509 4.201-5.543 5.863-17.48 5.863-11.772 0-16.947-1.713-17.476-5.863H5.26v-3.704c-.649-.359-1.208-.882-1.532-1.48l-3.405-6.3a2.633 2.633 0 01-.193-2.08 2.671 2.671 0 011.38-1.584C2.113 14.942 16.33 8 22.461 8s20.348 6.942 20.95 7.239a2.68 2.68 0 011.381 1.586zM22 13.189a.488.488 0 00-.493.481c0 .265.221.48.493.48a.486.486 0 00.492-.48c0-.265-.22-.48-.492-.48zm.994 8.032c1.71-.288 3.018-1.28 3.018-2.435H28c0 2.505-2.635 4.465-6 4.465s-6-1.96-6-4.465h1.989c0 1.154 1.307 2.147 3.017 2.435v-2.807H18.91v-1.938h2.095v-.594c-.874-.374-1.488-1.223-1.488-2.212 0-1.334 1.114-2.42 2.482-2.42s2.48 1.086 2.48 2.42c0 .989-.612 1.838-1.486 2.212v.594h2.094v1.938h-2.094v2.807z"}})])
          )
        }
      }
    